import React from 'react';
import BrandPage from '@/components/Pages/BrandPage';

export default function Brand() {
  return <BrandPage />;
}
